import { create } from 'zustand';
import { User } from '../types/auth';
import { AuthService } from '../services/authService';

interface AuthState {
    user: User | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    checkAuth: () => Promise<void>;
    login: (user: User) => void;
    logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    isAuthenticated: false,
    isLoading: true,
    checkAuth: async () => {
        set({ isLoading: true });
        try {
            const user = await AuthService.checkAuth();
            set({ user: user.user, isAuthenticated: !!user.user, isLoading: false });
        } catch (error) {
            set({ user: null, isAuthenticated: false, isLoading: false });
        }
    },
    login: (user: User) => {
        set({ user, isAuthenticated: true });
    },
    logout: async () => {
        try {
            await AuthService.logout();
        } catch (error) {
            console.error('Logout failed', error);
        } finally {
            set({ user: null, isAuthenticated: false });
        }
    },
}));
